import React from "react";

// Components
import Button from "components/UiKit/Button";
import TextField from "components/UiKit/FieldText";

// Lib
import * as yup from "yup";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import { shallowEqual } from "react-redux";
import { getDriverInstance } from "lib/driver";
import { patternRxpCheckEng } from "lib/helpers";
import { yupResolver } from "@hookform/resolvers/yup";
import { amplitudeInstance, events } from "constans/cookie";
import { useAppDispatch, useAppSelector } from "lib/hooks/useDispatch";

// Actions
import { createProject } from "pages/Projects/reducer";

import { NavigateFunction } from "react-router-dom";

type TUnit = {
  data?: any,
  text?: string,
  url?: string,
  navigate?: NavigateFunction,
  handlerCloseModal?: () => {},
  isAddItem?: string | undefined,
  isLibrary?: boolean | undefined,
};

interface TProjectsAdd {
  modalProps?: TUnit;
}

const textMatches = 'Use Latin symbols only.';
const textSymbols100 = 'The text must be less than 100 symbols';
const textSymbols200 = 'The text must be less than 200 symbols';

// Schema
const schema = yup.object({
  name: yup.string().matches(patternRxpCheckEng, textMatches).max(100, textSymbols100).required(textSymbols100),
  description: yup.string().matches(patternRxpCheckEng, textMatches).max(200, textSymbols200).required(textSymbols200),
}).required();
type FormData = yup.InferType<typeof schema>;

const ProjectsAdd: React.FC<TProjectsAdd> = (props) => {
  const dispatch = useAppDispatch();

  const drv = getDriverInstance();
  const isActive = drv?.isActive;

  const url = props?.modalProps?.url || "";
  const navigate = props?.modalProps?.navigate;

  const text = props?.modalProps?.text;
  const result = props?.modalProps?.data || [];
  const isLibrary = props?.modalProps?.isLibrary;
  const isAddItem = props?.modalProps?.isAddItem;

  const loading = useAppSelector(
    (store) => store.projects.loadingCreateProject,
    shallowEqual
  );
  const stepTutorial = useAppSelector(
    (store) => store.projects.stepTutorial,
    shallowEqual
  );

  const {
    register,
    handleSubmit,
    formState: {
      isDirty,
      isValid,
      errors,
    }
  } = useForm<FormData>({
    resolver: yupResolver(schema)
  });

  const handleSubmitTutorial = () => {
    const inputName = document.querySelector<HTMLInputElement>('#input-projects-name');
    const inputDescription = document.querySelector<HTMLInputElement>('#input-projects-description');

    const formData = {
      result: [
        {
          purity: 90,
          quantity: 1,
          prepackage: 1,
          supplier: "EBC",
          productType: "EBC",
          productId: 'EBC-03688',
        }
      ],
      isAddItem: true,
      name: inputName?.value || 'new_project',
      description: inputDescription?.value || 'description',
      title: "Compound Added to project",
      text: "Review or continue browsing. Contact<br/> us for any questions. Thank you!"
    };

    if(isActive) {
      dispatch(createProject(formData));
      drv.moveNext();
      return;
    }
  };

  const onSubmit = (data: FormData) => {
    const isText = !!text?.length ? { text: text } : {};
    const formData = {
      ...data,
      ...isText,
      isAddItem,
      result,
      isLibrary,
      text,
      url,
      navigate
    };

    dispatch(createProject(formData));

    const isCookie = Cookies.get("cookieName");
    if (isCookie) {
      amplitudeInstance.logEvent(events.create_project, { sent_form: true });
    }
  };

  const simpleDisabled = (!isValid && !isDirty);
  const disabled =  (isActive && stepTutorial === 1) ? false : simpleDisabled;

  return <div className="projects-modal" id="projects-modal-add">
    <div className="projects-modal__create flex flex-direction-column">
      <h4 className="projects-modal__title mb30">
        Add new project
      </h4>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="projects-modal__form flex flex-ai-center flex-jc-between flex-direction-column"
      >
        <div className="full-width">
          <TextField
            required
            name="name"
            label="Project name"
            id="input-projects-name"
            isError={!isActive && !!errors?.name}
            placeholder="Project name"
            className="full-width mb10"
            register={register("name")}
            msgError={!isActive && errors?.name ? errors?.name.message : ""}
          />
          <TextField
            required
            name="description"
            className="full-width"
            label="Project description"
            isError={!isActive && !!errors?.description}
            id="input-projects-description"
            placeholder="Project description"
            register={register("description")}
            msgError={!isActive && errors?.description ? errors?.description.message : ""}
          />
        </div>
        <div className="flex flex-jc-center">
          {!isActive && <Button
            type="submit"
            label="Create"
            variable="info"
            loading={loading}
            disabled={simpleDisabled}
          />}

          {isActive && <Button
            type="submit"
            label="Create"
            variable="info"
            loading={loading}
            disabled={disabled}
            onPress={handleSubmitTutorial}
            id="projects-modal-btn-create"
          />}
        </div>
      </form>
    </div>
  </div>;
};

export default ProjectsAdd;
